import { getNetworkState } from './connectivity';
import { ApiErrorKind, classifyApiError } from './apiErrors';

export const SAFE_GET_RETRY_MAX = 2;
export const SAFE_GET_RETRY_BASE_MS = 800;

export function isSafeGetRetryable(error) {
  const classified = classifyApiError(error);
  return classified.kind === ApiErrorKind.NETWORK || classified.kind === ApiErrorKind.TIMEOUT;
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function retrySafeGetRequest(axiosInstance, config) {
  const method = (config.method || 'get').toLowerCase();
  if (method !== 'get') {
    throw new Error('Only GET requests are eligible for safe retry');
  }

  let lastError;
  const maxAttempts = SAFE_GET_RETRY_MAX + 1;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    if (!getNetworkState().isOnline) {
      if (lastError) break;
      const offlineErr = new Error('No internet connection');
      offlineErr.code = 'ERR_NETWORK';
      throw offlineErr;
    }
    try {
      return await axiosInstance.request(config);
    } catch (error) {
      lastError = error;
      if (attempt >= SAFE_GET_RETRY_MAX || !isSafeGetRetryable(error)) {
        break;
      }
      if (!getNetworkState().isOnline) {
        break;
      }
      await sleep(SAFE_GET_RETRY_BASE_MS * (attempt + 1));
      config = { ...config, __safeRetryAttempt: attempt + 1 };
    }
  }

  if (lastError) throw lastError;
  const offlineErr = new Error('No internet connection');
  offlineErr.code = 'ERR_NETWORK';
  throw offlineErr;
}

export function isMutationMethod(method) {
  const m = (method || 'get').toLowerCase();
  return m !== 'get' && m !== 'head' && m !== 'options';
}
